export const ShipmentStatus = {
  IN_TRANSIT: 1,
  DELIVERED: 2,
  CANCELED: 3,
  NEW: 5,
  QUOTED: 6,
  DELAYED: 7,
  BOOKED: 8,
  INCOMPLETE: 9,
  AUTO_CLOSED: 10,
};

export const ShipmentStatusDisplay = {
  [ShipmentStatus.IN_TRANSIT]: "In transit",
  [ShipmentStatus.DELIVERED]: "Delivered",
  [ShipmentStatus.CANCELED]: "Canceled",
  [ShipmentStatus.NEW]: "New",
  [ShipmentStatus.QUOTED]: "Quoted",
  [ShipmentStatus.DELAYED]: "Delayed",
  [ShipmentStatus.BOOKED]: "Booked",
  [ShipmentStatus.INCOMPLETE]: "Incomplete",
  [ShipmentStatus.AUTO_CLOSED]: "Auto-closed",
};
